import { useMutation } from '@tanstack/react-query';

import { useRequest } from '@frontend/api';
import type { MutationFunction } from '@frontend/api';

export type UseBulkUpdateQuantitiesRequestBody = {
  quoteId: number;
  quantityData: Array<{
    quoteItemId: number;
    quantities: string;
    mostLikelyWonQuantity?: number;
    mostLikelyWonQuantityPercent?: number | null;
  }>;
  shouldReplaceExistingQuantities: boolean;
};

export type UseBulkUpdateQuantitiesResponseBody = null;

export const useBulkUpdateQuantities: MutationFunction<
  UseBulkUpdateQuantitiesResponseBody,
  UseBulkUpdateQuantitiesRequestBody
> = ({ query, requestOptions, queryOptions } = {}) => {
  const request = useRequest(requestOptions);

  return useMutation({
    mutationFn: ({ quoteId, ...body }) =>
      request(`/quotes/${quoteId}/update_quantities_for_multiple_quote_items`, {
        query,
        init: {
          method: 'POST',
          body,
        },
      }),
    ...queryOptions,
  });
};
